import React from "react"
import * as Styles from "./SurveyDetailsForm.styles"
import { t } from "ttag"
import { SurveyDetails } from "features/Surveys/CustomSurveys/models"

export const SurveyDetailsForm: React.FC<SurveyDetailsFormProps> = (props) => {
  return (
    <Styles.Container>
      {t`Survey details`}
      <Styles.Form>
        <Styles.InputContainer>
          <Styles.NameInput
            isDisabled={props.isReadOnly}
            label={t`Survey name`}
            placeholder={t`Your working conditions`}
            value={props.surveyDetails.name}
            onChange={(name) => props.onChange({ ...props.surveyDetails, name })}
            showRemainingCharCount
            maxLength={100}
          />
        </Styles.InputContainer>
        <Styles.InputContainer>
          <Styles.DescriptionInput
            isDisabled={props.isReadOnly}
            label={t`Description`}
            value={props.surveyDetails.description}
            onChange={(description) => props.onChange({ ...props.surveyDetails, description })}
            placeholder={t`
              This survey is offered to you to collect your feelings regarding your working conditions. 
              Thank you for your participation which will help us 
              to act better for your quality of life and working conditions.
            `}
            showRemainingCharCount
            maxLength={2000}
          />
        </Styles.InputContainer>
      </Styles.Form>
    </Styles.Container>

  )
}

interface SurveyDetailsFormProps {
  isReadOnly: boolean,
  surveyDetails: SurveyDetails,
  onChange: (surveyDetails: SurveyDetails) => void,
}

